module.exports = __webpack_public_path__ + "static/media/old_port.e14d5065.png";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/old_port.png
// module id = 31
// module chunks = 0